import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => {
    return {
        inactive: {
            opacity: 0
        },
        item: {
            justifyContent: "left"
        }
    }
})